// extracted by mini-css-extract-plugin
module.exports = {"collectDetails":"styles_collectDetails__vPBNk","header":"styles_header__2-xrd","active":"styles_active__1yIC2","collectContent":"styles_collectContent__IRMFg"};